import React, { useState, useEffect, useCallback } from "react";
import apiClient from "../../../api/apiClient";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import { getTags, useImageWithFallback } from "../../../utils/utils";
import { PopupModel, ShowMoreText, Intersect, SearchableSelect, AlertMassage} from "../../shared";
import { ForwardIcon, LeftArrow } from "../../../utils/FontIcon";
import ViewCourse from "./ViewCourse";
import { GETCOURSELIST, GROUPCOURSEASSIGMENT, GETGROUPLIST } from '../../../utils/ApiEndPoint';
import { useLogin } from '../../../context/LoginContext';

const CourseImage = ({ course }) => {
    const thumbnailUrl = course?.thumbnailUrl || '/lms/img/no-video-icon.png';
    const fallbackUrl = '/lms/img/no-video-icon.png';
    const [imgSrc, handleImgError] = useImageWithFallback(thumbnailUrl, fallbackUrl);
    return (
        <img src={imgSrc} onError={handleImgError} alt={course.title} className="img-fluid" />
    );
}
export default function AssignCourseOnGroup() {
    const { user } = useLogin();
    const totalCoursesToShow = 10;
    const [searchedCourses, setSearchedCourses] = useState([]);
    const [allCourses, setAllCourses] = useState([]);
    const [allCoursesMaster, setAllCoursesMaster] = useState([]);
    const [roles, setRoles] = useState('');
    const [roleName, setRoleName] = useState('');
    const [searchAssignCourses, setSearchAssignCourses] = useState([]);
    const [AssignCourse, setAssignCourse] = useState([]);
    const [assignCourseMaster, setAssignCourseMaster] = useState([]);
    const [loadingAssignCourse, setLoadingAssignCourse] = useState({ error: '', loading: false });
    const [search, setSearch] = useState('');
    const [searchAssign, setSearchAssign] = useState('');
    const [totalAssignedCoursesInitial, setTotalAssignedCoursesInitial] = useState(0);
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: [],
    });
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    });
    const [visibleCount, setVisibleCount] = useState(totalCoursesToShow);
    const [visibleCountAssigned, setVisibleCountAssigned] = useState(totalCoursesToShow);
    const [waitForResponse, setWaitForResponse] = useState(false);
    const [roleGroupMaster, setRoleGroupMaster] = useState([]);
    const [selectedRoleGroup, setSelectedRoleGroup] = useState({});
    // Fetch roles and courses on mount
    useEffect(() => {
        fetchCourse();
        fetchgroup();
    }, []);
    useEffect(() => {
        const searchLower = search.toLowerCase();
        const searchedCourse = allCourses.filter(item =>
            item.title?.toLowerCase().includes(searchLower) ||
            (Array.isArray(item.tags) ? item.tags.join(' ').toLowerCase() : '').includes(searchLower)
        );
        setSearchedCourses(searchedCourse);
    }, [allCourses, search]);
    useEffect(() => {
        setVisibleCount(totalCoursesToShow);
    }, [searchedCourses]);

    useEffect(() => {
        const searchLower = searchAssign.toLowerCase();
        const searchedCourse = AssignCourse.filter(item =>
            item.title?.toLowerCase().includes(searchLower) ||
            (Array.isArray(item.tags) ? item.tags.join(' ').toLowerCase() : '').includes(searchLower)
        );
        setSearchAssignCourses(searchedCourse);
    }, [AssignCourse, searchAssign]);
    useEffect(() => {
        setVisibleCountAssigned(totalCoursesToShow);
    }, [searchAssignCourses]);

    // Fetch all courses (master copy)
    const fetchCourse = () => {
        apiClient.get(GETCOURSELIST)
            .then((response) => {
                if (response.status === 200) {
                    const allPublishedCourse = response.data.filter(course => course.status === 'published' && course.isDeleted !== true && course.accessMode === "Mandatory");
                    const sortedCourses = allPublishedCourse.sort((a, b) => a.title.localeCompare(b.title));
                    setAllCoursesMaster(sortedCourses);
                }
            }).catch(() => {
                console.log('Loading Failed');
            });
    };

    const fetchgroup = () => {
        const alertObj = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        };
        apiClient.get(GETGROUPLIST)
            .then((response) => {
                if (response.status === 200) {
                    const groupMaster = response.data.data.sort((a, b) => a.name.localeCompare(b.name));
                    setRoleGroupMaster(groupMaster);
                } else {
                    setShowAlert(alertObj);
                }
            }).catch(() => {
                setShowAlert(alertObj);
            });
    }

    // Fetch assigned courses for a selected role
    const fetchAssignedCourses = async (selectedGroupId) => {
        setLoadingAssignCourse({ error: '', loading: true });
        try {
            const response = await apiClient.get(`${GROUPCOURSEASSIGMENT}/group/${selectedGroupId}`);
            const assignedCourseIds = [];
            response?.data?.assignment?.courseIds?.forEach(course => {
                assignedCourseIds.push(course._id);
            });
            // Right panel: Assigned courses (present in course master)
            const assignedCourses = allCoursesMaster.filter(course => assignedCourseIds.includes(course._id));
            setAssignCourse(assignedCourses);
            setAssignCourseMaster(assignedCourses);
            setTotalAssignedCoursesInitial(assignedCourses.length);
            // Left panel: Courses not assigned to this role
            const unassignedCourses = allCoursesMaster.filter(course => !assignedCourseIds.includes(course._id));

            setAllCourses(unassignedCourses);
        } catch (err) {
            setAssignCourse([]);
            setAssignCourseMaster([]);
            setTotalAssignedCoursesInitial(0);

            setAllCourses(allCoursesMaster); // fallback: show all courses on left if error
        } finally {
            setLoadingAssignCourse({ error: '', loading: false });
        }
    };

    const handleChangeGroup = useCallback((value) => {
        setRoles(value);

        // Find the selected group object for display name
        const selectedGroupObj = roleGroupMaster.find(g => g._id === value);
        setSelectedRoleGroup(selectedGroupObj);

        // Fetch assigned courses for this group
        if (selectedGroupObj) {
            fetchAssignedCourses(selectedGroupObj?._id);
        }

    }, [roleGroupMaster, allCoursesMaster]);

    // confirm before removing assigned course
    const confirmRemove = (course) => {
        setPopupData({
            show: true,
            title: 'Remove Confirmation',
            type: 'confirmRemove',
            selectedItem: course,
        })
    };
    // Remove from assigned courses
    const handleRemoveAssignedCourse = (courseToRemove) => {
        const sortedCourses = [...allCourses, courseToRemove].sort((a, b) => a.title.localeCompare(b.title));
        setAllCourses(sortedCourses);
        const isfound = isOldSelectedCourse(courseToRemove._id);
        if (isfound) {
            setAssignCourseMaster(prev => prev.filter(course => course._id !== courseToRemove._id));
        }
        setAssignCourse(prev => prev.filter(course => course._id !== courseToRemove._id));
    };

    // Save assignment
    const handleSubmit = (e) => {
        e.preventDefault();
        setWaitForResponse(true);
        const payload = {
            groupId: selectedRoleGroup?._id,
            courseIds: AssignCourse.map(c => c._id),
            assignedBy: user?.name // Replace with actual logged-in user if available
        };
        apiClient.post(GROUPCOURSEASSIGMENT, payload).then((response) => {
            if (response.status === 200 || response.status === 201) {
                setShowAlert({
                    type: 'success',
                    title: 'Success',
                    msg: `Course assigned to ${selectedRoleGroup?.name} successfully!`,
                    show: true
                });
                fetchAssignedCourses(selectedRoleGroup?._id);
            } else {
                setShowAlert({
                    type: 'danger',
                    title: 'Error',
                    msg: response.data.message || `course assigned to ${selectedRoleGroup?.name} failed!`,
                    show: true
                });
            }
        }).catch((error) => {
            setShowAlert({
                type: 'danger',
                title: 'Error',
                msg: error?.data?.error || `course assigned to ${selectedRoleGroup?.name} failed!`,
                show: true
            });
        }).finally(() => {
            setWaitForResponse(false);
        });
    };

    // Clear alert
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }

    // Select/deselect course checkboxes
    const handelSelected = (selectedCourse) => {
        setAllCourses(allCourses.filter(course => course._id !== selectedCourse._id));
        setAssignCourse(prev => [selectedCourse, ...prev]);
    };
    const isOldSelectedCourse = (courseId) => {
        return assignCourseMaster.some(c => c._id === courseId);
    }

    // Reset form
    const resetForm = () => {
        setSearch('');
        setSearchAssign('');
        setAllCourses([]);
        setAssignCourse([]);
        setRoles('');
        setRoleName('');
        // setCurrentPage(1);
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: {},
        });
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        });
        setVisibleCount(totalCoursesToShow);
        setVisibleCountAssigned(totalCoursesToShow);
        setLoadingAssignCourse({ error: '', loading: false });
        setAssignCourseMaster([]);

    };
    const handleOpenModal = (item) => {
        setPopupData({
            show: true,
            title: item.title,
            type: 'course',
            selectedItem: item,
        })
    };
    const handleCloseModal = () => {
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: {},
        })
    };


    return (
        <>
            <Col lg={12} >
                <Row className="mt-1 mb-4">
                    {roleGroupMaster.length ?
                        <Col md={12}>
                            <SearchableSelect
                                selectedRole={selectedRoleGroup?.name}
                                onChange={handleChangeGroup}
                                options={roleGroupMaster.map(group => ({
                                    value: group._id,
                                    label: group.name
                                }))}
                                placeholder="Choose a Group"
                            />
                        </Col>
                        : null}
                    {selectedRoleGroup?.name ? <Col md={12} className="pt-2">
                        <div className="text-muted small">Roles under this group are : 
                            <ShowMoreText text={(selectedRoleGroup?.roles.join(', ')).replace(/,/g, ', ')} previewLength={100} hasbutton={true} styleClass='fw-semibold text-dark' />
                        </div>
                    </Col> : null}
                </Row>
                <Row style={{paddingBottom:'1rem'}}>
                    {/* All Courses Panel */}
                    <Col md={5} className="pright0">
                        <div className="video-listing-bg">
                            <h6 className="mb-3">Course Library <span className="course-count">({allCourses.length})</span></h6>
                            {!loadingAssignCourse?.loading && (
                                <Form.Control
                                    name='search'
                                    placeholder="Search course..."
                                    type="search"
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    className="mb-3"
                                />
                            )}

                            <div className="listing-newscroll" style={{ height: '280px', overflowY: 'auto', overflowX: 'hidden' }}>
                                {!roles ? <Row><Col md={12} className="text-center">

                                    <div className="nocourse-addedbox">"No course has been assigned. <br /><strong>Choose a Role - </strong>to see your courses."</div></Col></Row>
                                    :
                                    loadingAssignCourse?.loading ? <p>Loading Course</p> :
                                        searchedCourses.length === 0 ? (
                                            <div className="text-muted nocourse-addedbox">No courses found.</div>
                                        ) : searchedCourses.slice(0, visibleCount).map((course, idx, arr) => {
                                            const isLast = idx === arr.length - 1;
                                            return (
                                                <React.Fragment key={course._id}>
                                                    <Row style={{ marginBottom: '10px' }} className="border rounded shadow-sm bg-white assign-course-list">
                                                        <Col md={3} onClick={e => {
                                                            e.preventDefault();
                                                            handleOpenModal(course);
                                                        }} style={{ cursor: 'pointer', padding: '0px' }}>
                                                            <CourseImage course={course} />
                                                        </Col>
                                                        <Col md={8}>
                                                            <div style={{ flex: 1 }}>
                                                                <h5><ShowMoreText text={course.title} previewLength={25} hasbutton={false} styleClass='fw-semibold' /></h5>
                                                                <div style={{ fontSize: '12px' }}><span>Keywords:</span> <span style={{ fontSize: 12, color: '#666' }}>{course.tags && course.tags.length ? getTags(course.tags) : '—'}</span></div>
                                                                <span style={{ fontSize: '12px' }}>Description:</span> <ShowMoreText text={course.description} previewLength={65} hasbutton={false} styleClass='text-muted' inlineStyle={{ fontSize: '12px' }} />
                                                            </div>
                                                        </Col>
                                                        <Col md={1} className="add-arrow-btn" onClick={() => handelSelected(course)}>
                                                            <ForwardIcon style={{ fontSize: '25px' }} />
                                                        </Col>
                                                    </Row>
                                                    {isLast && searchedCourses.length > visibleCount && (
                                                        <Intersect
                                                            onIntersect={() => setVisibleCount(c => Math.min(c + totalCoursesToShow, searchedCourses.length))}
                                                            disabled={visibleCount >= searchedCourses.length}
                                                        />
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                }
                            </div>
                        </div>
                    </Col>
                    {/* Center Add Button */}
                    <Col md={2} className="v-line text-center d-flex flex-column justify-content-center align-items-center p0" style={{ height: '400px' }}>
                    </Col>
                    {/* Assigned Courses Panel */}
                    <Col md={5} className="pleft0">
                        <div className="video-listing-bg">
                            <h6 className="mb-3">Courses – Assigned <span className="course-count">({assignCourseMaster.length})</span> / New <span className="new-course-count">({AssignCourse.length - assignCourseMaster.length})</span></h6>
                            {!loadingAssignCourse?.loading && (
                                <Form.Control
                                    name="searchAssign"
                                    placeholder="Search assigned course..."
                                    type="search"
                                    value={searchAssign}
                                    onChange={e => setSearchAssign(e.target.value)}
                                    className="mb-3"
                                />
                            )}
                            <div className="listing-newscroll" style={{ height: '280px', overflowY: 'auto', overflowX: 'hidden' }}>
                                {!roles ? <Row><Col md={12} className="text-center">
                                    <div className="nocourse-addedbox">"Please <strong>Choose a Role</strong> to view <br />assigned courses on selected role."</div></Col></Row>
                                    :
                                    loadingAssignCourse?.loading ? <p>Loading Assigned Course</p> :
                                        AssignCourse.length === 0 ? (
                                            <div className="nocourse-addedbox">
                                                <strong>No courses assigned yet.</strong>
                                                <span className="d-block">
                                                    <small>(Select a course from the left panel to begin.)</small>
                                                </span>
                                            </div>
                                        ) : searchAssignCourses.slice(0, visibleCountAssigned).map((course, idx, arr) => {
                                            const isLast = idx === arr.length - 1;
                                            const isnew = !assignCourseMaster.some(c => c._id === course._id);
                                            return (
                                                <React.Fragment key={course._id}>
                                                    <Row style={{ marginBottom: '10px', backgroundColor: `${isnew ? '#ffffff' : '#fdfcfb'}` }} className="border rounded shadow-sm already-assigned-courselist">
                                                        {isnew ? <div className="newly-added-badge">New</div> : <div className="added-badge">Assigned</div>}
                                                        <Col md={1} className="unassign-arrowbtn" onClick={() => confirmRemove(course)}>
                                                            <LeftArrow style={{ fontSize: '25px' }} />
                                                        </Col>
                                                        <Col md={3} onClick={e => {
                                                            e.preventDefault();
                                                            handleOpenModal(course);
                                                        }} style={{ cursor: 'pointer', }}>
                                                            <CourseImage course={course} />
                                                        </Col>
                                                        <Col md={8}>
                                                            <div style={{ flex: 1 }}>
                                                                <h5><ShowMoreText text={course.title} previewLength={25} hasbutton={false} styleClass='fw-semibold' /></h5>
                                                                <div style={{ fontSize: '12px' }}><span>Keywords:</span> <span style={{ fontSize: 12, color: '#666' }}>{course.tags && course.tags.length ? getTags(course.tags) : '—'}</span></div>
                                                                <span style={{ fontSize: '12px' }}>Description:</span><ShowMoreText text={course.description} previewLength={65} hasbutton={false} styleClass='text-muted' inlineStyle={{ fontSize: '12px' }} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {isLast && searchAssignCourses.length > visibleCountAssigned && (
                                                        <Intersect
                                                            onIntersect={() => setVisibleCountAssigned(c => Math.min(c + totalCoursesToShow, searchAssignCourses.length))}
                                                            disabled={visibleCountAssigned >= searchAssignCourses.length}
                                                        />
                                                    )}
                                                </React.Fragment>
                                            )
                                        })}
                            </div>
                        </div>
                    </Col>
                </Row>

            </Col>
            <Col lg={12}>
                {/* Action Buttons */}
                {totalAssignedCoursesInitial !== AssignCourse.length || totalAssignedCoursesInitial !== assignCourseMaster.length ?
                    <div className="d-flex gap-3 justify-content-end mt-3">
                        <Button variant="outline-secondary" title="Reset" type="button" className="px-4" disabled={waitForResponse} onClick={resetForm}>
                            {waitForResponse ? <><Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                                variant="primary"
                            />
                                Wait...</> : 'Reset'}
                        </Button>

                        <Button type="submit" title="Assign Courses" className="save-btn px-3" disabled={waitForResponse} onClick={handleSubmit}>

                            {waitForResponse ? <><Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                                variant="light"
                            />
                                Wait...</> : 'Assign Courses'}
                        </Button>

                    </div>
                    : null}

                {/* Alert/Popup */}
            </Col>
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }
            {popupData.show ?
                <PopupModel
                    size={popupData.type === 'course' ? 'xl' : 'md'}
                    showModal={popupData.show}
                    handleCloseModal={handleCloseModal}
                    headerStyle={popupData.type === 'course' ? { padding: '0.5rem', paddingBlock: '0.5rem' } : { padding: '0.5rem', paddingBlock: '1rem' }}
                    footerContent={popupData.type === 'confirmRemove' ? <div className="text-end w-100">
                        <Button variant="outline" onClick={handleCloseModal} className="me-2">Cancel</Button>
                        <Button variant="danger" onClick={() => {
                            handleRemoveAssignedCourse(popupData.selectedItem);
                            handleCloseModal();
                        }}>Remove</Button>
                    </div> : null}
                    title={popupData.title}
                    type={popupData.type}
                >
                    {popupData.type === 'course' ? <ViewCourse courseId={popupData.selectedItem._id} />
                        : <p>Do you want to remove course <strong>{popupData?.selectedItem?.title}</strong> from <strong>{roleName}</strong> role ?</p>}
                </PopupModel> :
                null}
        </>
    );
}